import React from 'react';
import './index.css';

import ErrorBoundary from 'app/providers/errorBoundary';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AppInsightsContextProvider } from './app/providers/AppInsights';
import { AppRouter } from './app/providers/router';


function App() {
	return (
		<AppInsightsContextProvider>
			<ErrorBoundary>
				<ToastContainer/>
				<AppRouter />
			</ErrorBoundary>
		</AppInsightsContextProvider>
	);
}

export default App;
